import { cn } from '@/lib/utils';

type SpinnerProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
};

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-16 w-16',
};

const Spinner = ({ className, size = 'md' }: SpinnerProps) => (
  <div
    className={cn(
      'text-muted-foreground animate-spin rounded-full border-2 border-current border-t-transparent',
      sizeClasses[size],
      className,
    )}
    role="status"
    aria-label="Loading"
  >
    <span className="sr-only">Loading...</span>
  </div>
);

export { Spinner };
